<template>

<app-panel v-on:close="$emit('close')" :theme="(is.saved) ? 'green' : 'default'">
		
	<div class="location-image" v-bgimage="event.image" />

	<app-panel-content class="location-text"> 

        <h1>{{ event.name }}</h1>
        <h2>{{ $con.schedule.times[event.schedule.time] }} - {{ $con.schedule.times[event.schedule.time + event.schedule.duration] }}</h2>
        <p>Enter a brief description of where your event is within the room.</p>
    
	</app-panel-content>

	<app-panel-content>

		<app-input-text placeholder="Enter location" :disabled="is.loading || is.saved" :stacked="true" v-model="model.location" :validation="$v.model.location" />

	</app-panel-content>

	<app-panel-content class="location-buttons" v-if="!is.saved">

		<app-button text="Confirm" :loading="is.loading" :disabled="!model.location" v-on:click.native.stop="onConfirmClick" v-if="!is.saved" />
		<app-button text="Close" theme="simple" v-on:click.native.stop="$emit('close')" />

	</app-panel-content>

	<app-panel-content v-if="is.saved">

		<app-button text="Close" theme="darkgreen" v-on:click.native.stop="$emit('close')" />

	</app-panel-content>

</app-panel>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {

	mixins: [validationMixin],

	props: ['data' ,'event'],

	data: function() {

		return {
			is: {
				loading: false,
                saved: false
			},
			model: {
				location: ''
			}
		}

	},

	validations: {
		model: {
			location: {
				required,
                minLength: minLength(1)
			}
		}
	},

	created: function() {

		this.$pubsub.$emit('offset', true)

	},

	beforeDestroy: function() {

		this.$pubsub.$emit('offset', false)

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$api.patch(['convention/schedule/event', this.event.id ,'location'], this.model).then(function(json) {

				this.is.loading = false
                this.is.saved = true

                this.$emit('change', json.location)
				
			}.bind(this), function() {

				this.status = this.$constants.status.failed

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.location-image {
    height: 200px;
    background-position: 50% 50%;
    background-size: cover;
    margin-bottom: 20px;
}

.location-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
}

.location-text h1 {
    font-size: 24px;
    margin-bottom: 10px;
}

.location-text h2 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.location-text p {
    font-size: 16px;
    line-height: 20px;
    color: #fff;
}

</style>
